import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 18v-11a2 2 0 0 1 2 -2h.5a.5 .5 0 0 0 .5 -.5a.5 .5 0 0 1 .5 -.5h3a.5 .5 0 0 1 .5 .5a.5 .5 0 0 0 .5 .5h.5a2 2 0 0 1 2 2v11a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2","key":"svg-0"}],["path",{"d":"M10 17h4","key":"svg-1"}],["path",{"d":"M10 14h4","key":"svg-2"}]]

const IconBatteryVertical2 = createReactComponent('outline', 'battery-vertical-2', 'BatteryVertical2', __iconNode);

export default IconBatteryVertical2;